import styled from '@emotion/styled';
import { Variables } from '../variables';

// Above MUI modals/drawers (1300), so menus opened inside them stay visible.
export const MENU_Z_INDEX = 1301;

export const Menu = styled.div`
    display: block;
    box-sizing: border-box;
    padding: 8px 0px;
    // The popper root carries the max-height for the side the menu opened on;
    // inherit it here so the menu scrolls instead of overflowing the viewport.
    max-height: inherit;
    overflow-y: auto;

    user-select: none;

    border-radius: ${Variables.Rounded.small};
    background-color: ${Variables.Colors.white};
    box-shadow: ${Variables.Shadows.large}, ${Variables.Shadows.border};
`;
